/**
 * Canonical industry slugs surfaced in the IndustryUpdate workbench dropdown.
 * Mirror of the lists in func-axn-analyst-api/src/lib/industries.ts and
 * func-axn-operations-api/src/lib/industries.ts. Keep in sync.
 *
 * "All industries" is represented by an empty selection / null on the wire,
 * which the API stores as `industries IS NULL`.
 */

export interface IndustryOption {
  value: string;   // lowercase slug stored in the CSV
  label: string;   // analyst-facing display label
}

export const CANONICAL_INDUSTRIES: IndustryOption[] = [
  { value: 'finance', label: 'Finance' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'retail', label: 'Retail' },
  { value: 'technology', label: 'Technology' },
  { value: 'government', label: 'Government' },
  { value: 'education', label: 'Education' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'energy', label: 'Energy' },
  { value: 'logistics', label: 'Logistics' },
  { value: 'professional_services', label: 'Professional Services' },
  { value: 'nonprofit', label: 'Nonprofit' },
  { value: 'media', label: 'Media' },
  { value: 'telecommunications', label: 'Telecommunications' },
  { value: 'transportation', label: 'Transportation' },
  { value: 'legal', label: 'Legal' },
  { value: 'hospitality', label: 'Hospitality' },
];

const LABEL_BY_VALUE = new Map(CANONICAL_INDUSTRIES.map((i) => [i.value, i.label]));

export function industryLabel(value: string): string {
  return LABEL_BY_VALUE.get(value) ?? value;
}
